import script from "./activityOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./activityOrders.vue?vue&type=script&setup=true&lang=js"

import "./activityOrders.vue?vue&type=style&index=0&id=8f9fc4e2&lang=scss"

const __exports__ = script;

export default __exports__